import { render } from "./Level.vue?vue&type=template&id=89695a08&scoped=true"
import script from "./Level.vue?vue&type=script&lang=js"
export * from "./Level.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-89695a08"

export default script